import { render } from "./ExportedHorsesPage.vue?vue&type=template&id=1391d738"
import script from "./ExportedHorsesPage.vue?vue&type=script&lang=js"
export * from "./ExportedHorsesPage.vue?vue&type=script&lang=js"

import "./ExportedHorsesPage.vue?vue&type=style&index=0&id=1391d738&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__